import React from 'react';
import PropTypes from 'prop-types';

import { headerClass, bodyClass, errorClass } from './FeedbackDialog.less';
import { colors } from 'styles/provider';

// Material UI components
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import { MenuItem } from 'material-ui';

const hintStyle = {
  color: colors.clrLabelLight,
  fontStyle: 'italic',
  bottom: '',
  top: '12px',
};

const ErrorField = ({ message }) => {
  return <div className={errorClass}>{message}</div>;
};

ErrorField.propTypes = {
  message: PropTypes.string,
};

const renderError = (error, fm) => {
  let locale = '';
  switch (error) {
    case 'regexp':
      locale = 'feedback.error.emailRegexp';
      break;
    case 'email':
      locale = 'feedback.error.email';
      break;
    case 'type':
      locale = 'feedback.error.type';
      break;
    case 'subject':
      locale = 'feedback.error.subject';
      break;
    case 'description':
      locale = 'feedback.error.description';
      break;
    case 'error':
      locale = 'feedback.error.error';
      break;
  }
  return <ErrorField message={fm({ id: locale })} />;
};

const FeedbackDialog = ({
  visible,
  onInput,
  onSend,
  onCancel,
  getInput,
  formatMessage,
  missingFields,
  validEmail,
  error,
}) => {
  const typeOptions = ['incident', 'improvement', 'other'];
  return (
    <Dialog
      title={<div style={{ color: colors.clrSecondary }}>{formatMessage({ id: 'feedback.title' })}</div>}
      open={visible}
      bodyStyle={{ 'overflow-y': 'auto' }}
      actions={[
        <FlatButton label={formatMessage({ id: 'feedback.form.cancel' })} onClick={onCancel} />,
        <RaisedButton label={formatMessage({ id: 'feedback.form.send' })} onClick={onSend} primary />,
      ]}
    >
      <div className={headerClass} style={{ paddingTop: '0' }}>
        {formatMessage({ id: 'feedback.form.type' })}
      </div>
      <div className={bodyClass}>
        <Paper className={bodyClass} style={{ padding: '0 0 0 1rem', width: '25rem' }}>
          <SelectField
            hintText={formatMessage({ id: 'feedback.form.typeHint' })}
            onChange={(e, v) => onInput('type')(typeOptions[v])}
            value={getInput('type')}
            underlineShow={false}
            fullWidth
            style={{ display: 'default' }}
          >
            {typeOptions.map(t => (
              <MenuItem key={t} value={t} primaryText={formatMessage({ id: 'feedback.form.type.' + t })} />
            ))}
          </SelectField>
        </Paper>
      </div>

      {missingFields.includes('type') && renderError('type', formatMessage)}

      <div className={headerClass}>{formatMessage({ id: 'feedback.form.email' })}</div>
      <Paper className={bodyClass} style={{ padding: '0 1rem' }}>
        <TextField
          hintText={formatMessage({ id: 'feedback.form.emailHint' })}
          onChange={(e, v) => onInput('email')(v)}
          underlineShow={false}
          fullWidth
          value={getInput('email')}
        />
      </Paper>

      {getInput('email') && getInput('email') !== '' && !validEmail(getInput('email'))
        ? renderError('regexp', formatMessage)
        : null}

      {missingFields.includes('email') && renderError('email', formatMessage)}

      <div className={headerClass}>{formatMessage({ id: 'feedback.form.subject' })}</div>
      <Paper className={bodyClass} style={{ padding: '0 1rem' }}>
        <TextField
          hintText={formatMessage({ id: 'feedback.form.subjectHint' })}
          onChange={(e, v) => onInput('subject')(v)}
          underlineShow={false}
          fullWidth
          value={getInput('subject')}
        />
      </Paper>

      {missingFields.includes('subject') && renderError('subject', formatMessage)}

      <div className={headerClass}>{formatMessage({ id: 'feedback.form.text' })}</div>
      <Paper className={bodyClass} style={{ padding: '0 1rem' }}>
        <TextField
          hintText={formatMessage({ id: 'feedback.form.textHint' })}
          hintStyle={hintStyle}
          onChange={(e, v) => onInput('description')(v)}
          underlineShow={false}
          multiLine
          fullWidth
          rows={5}
        />
      </Paper>

      {missingFields.includes('description') && renderError('description', formatMessage)}

      {error && <div style={{ padding: '2rem 0 0 0', fontWeight: 'bold' }}>{renderError('error', formatMessage)}</div>}
    </Dialog>
  );
};

FeedbackDialog.propTypes = {
  visible: PropTypes.bool,
  onInput: PropTypes.func,
  onSend: PropTypes.func,
  onCancel: PropTypes.func,
  getInput: PropTypes.func,
  formatMessage: PropTypes.func,
  missingFields: PropTypes.arrayOf(PropTypes.string),
  validEmail: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // string or null
};

export default FeedbackDialog;
